'use client';
import React from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const data = [
  { name: 'Occupied', value: 3214, fill: 'var(--primary)' },
  { name: 'Reserved', value: 224, fill: 'var(--accent)' },
  { name: 'Available', value: 1382, fill: 'var(--muted-foreground)' },
];

const cemeteries = [
  { id: 'cem-mthatha', name: 'Mthatha Cemetery', total: 2800, occupied: 2052, pct: 73 },
  { id: 'cem-libode', name: 'Libode Cemetery', total: 1200, occupied: 748, pct: 62 },
  { id: 'cem-ngqeleni', name: 'Ngqeleni Cemetery', total: 820, occupied: 414, pct: 50 },
];

export default function OccupancyBreakdown() {
  return (
    <div className="card-base p-5 h-full">
      <h2 className="text-base font-600 text-foreground mb-4">Plot Occupancy</h2>
      <ResponsiveContainer width="100%" height={160}>
        <RadialBarChart innerRadius="40%" outerRadius="90%" data={data} startAngle={90} endAngle={-270}>
          <RadialBar dataKey="value" cornerRadius={4} />
          <Tooltip
            formatter={(v: number, name: string) => [`${v.toLocaleString('en-ZA')} plots`, name]}
            contentStyle={{
              background: 'var(--card)',
              border: '1px solid var(--border)',
              borderRadius: 8,
              fontSize: 12,
            }}
          />
          <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12 }} />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="mt-4 space-y-3">
        {cemeteries.map((c) => (
          <div key={c.id}>
            <div className="flex items-center justify-between text-xs mb-1">
              <span className="font-500 text-foreground">{c.name}</span>
              <span className="font-600 tabular-nums text-muted-foreground">{c.pct}%</span>
            </div>
            <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full ${c.pct >= 90 ? 'bg-negative' : c.pct >= 70 ? 'bg-accent' : 'bg-primary'}`}
                style={{ width: `${c.pct}%` }}
              />
            </div>
            <p className="text-[11px] text-muted-foreground mt-0.5">
              {c.occupied.toLocaleString('en-ZA')} / {c.total.toLocaleString('en-ZA')} plots
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}